import Typography from "@mui/material/Typography";
import { StarSharp } from "@mui/icons-material";
import Link from "@mui/material/Link";
import { HgVendor } from "../../../../types/taxonomy";
import { useNavigate } from "react-router-dom";
import { CompanyLogo } from "../../../../components/CompanyLogo";

interface Props {
  items: HgVendor[];
}

export const VendorsList: React.FC<Props> = ({ items }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: "19px",
      }}
    >
      <Typography variant="h5">{`Vendors (${items.length})`}</Typography>

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {items.slice(0, 10).map(({ id, name, url }) => (
          <div
            key={id}
            style={{
              display: "flex",
              gap: "8px",
            }}
          >
            <div>
              <CompanyLogo
                domain={url}
                size={20}
                fallback={<StarSharp />}
                variant="circular"
              />
            </div>
            <div style={{ flex: 1, display: "flex", gap: "8px" }}>
              <Link
                href={`/catalog/product/vendor/${id}`}
                underline="none"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/catalog/product/vendor/${id}`);
                }}
              >
                <Typography variant="body1" color="primary">
                  {name}
                </Typography>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
